import { render, staticRenderFns } from "./OutageHistoryList.vue?vue&type=template&id=744679f5&scoped=true"
import script from "./OutageHistoryList.vue?vue&type=script&lang=js"
export * from "./OutageHistoryList.vue?vue&type=script&lang=js"
import style0 from "./OutageHistoryList.vue?vue&type=style&index=0&id=744679f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744679f5",
  null
  
)

export default component.exports